import script from "./FRotateImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FRotateImage.vue?vue&type=script&setup=true&lang=ts"

import "./FRotateImage.vue?vue&type=style&index=0&id=8a7dcc68&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a7dcc68"]])

export default __exports__